<button type="button" class="accordion__header" (click)="toggle()">
  @if (iconPath) {
    <img [src]="iconPath" alt="Accordion Icon" class="accordion__icon">
  }
  <section class="texts">
    <h3 class="accordion__title">{{ header() }}</h3>
    @if (subtitle()) {
      <h3 class="accordion__subtitle">{{ subtitle() }}</h3>
    }
  </section>
  <img src="/assets/lib/core/icons/chevron.svg" alt="Arrow Down" class="accordion__chevron">
</button>

<div class="accordion__panel">
  <div class="accordion__panel-inner">
    <ng-content></ng-content>
  </div>
</div>
